// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3N_Ee","list":"BalanceDue_list__1K2ij","listRow":"BalanceDue_listRow__3QcQ7","total":"BalanceDue_total__1eVRg"};